'use client';

import { useState } from 'react';
import { ArrowRightIcon } from '@phosphor-icons/react';
import { TransactionRow } from '../screen/TransactionRow';
import type { CategoryIndex } from '../screen/categoryIndex';
import type { ScreenTransaction } from '../screen/types';
import type { MerchantRow } from './buildMerchantRows';

interface Props {
  rows: readonly MerchantRow<ScreenTransaction>[];
  categoryIndex: CategoryIndex;
  onSeeAll?: () => void;
  onOpenDetails?: (txId: string) => void;
}

export function TopMerchantsStrip({ rows, categoryIndex, onSeeAll, onOpenDetails }: Props) {
  const top = rows.slice(0, 5);
  const [expandedId, setExpandedId] = useState<string | null>(null);

  return (
    <div>
      <div className="mb-2">
        <h3 className="text-2xs font-medium tracking-[0.15em] text-text-tertiary uppercase">
          Transações frequentes
        </h3>
      </div>
      {top.length === 0 ? (
        <p className="rounded-xl bg-surface-sunken px-3 py-4 text-sm text-text-tertiary">
          Sem transações neste período.
        </p>
      ) : (
        <ul className="divide-y divide-border overflow-hidden rounded-xl border border-border bg-surface" role="list">
          {top.map((m) => (
            <li key={m.key} className="relative">
              <span
                aria-label={`${m.count} transações`}
                className="pointer-events-none absolute top-1/2 right-3 z-10 -translate-y-1/2 rounded-full bg-surface-sunken px-2 py-0.5 font-mono text-3xs font-semibold text-text-secondary tabular-nums"
              >
                {m.count}×
              </span>
              <TransactionRow
                tx={m.sampleTx}
                expanded={expandedId === m.sampleTx.id}
                onToggle={() =>
                  setExpandedId((cur) => (cur === m.sampleTx.id ? null : m.sampleTx.id))
                }
                onOpenDetails={(id) => onOpenDetails?.(id)}
                categoryIndex={categoryIndex}
              />
            </li>
          ))}
        </ul>
      )}

      {top.length > 0 && onSeeAll && (
        <button
          type="button"
          onClick={onSeeAll}
          className="mt-3 flex h-11 w-full items-center justify-center gap-2 rounded-xl border border-border bg-surface text-sm font-semibold text-text-primary transition hover:bg-surface-sunken"
        >
          Ver todas as transações
          <ArrowRightIcon className="size-4" weight="bold" />
        </button>
      )}
    </div>
  );
}
